// extracted by mini-css-extract-plugin
export var card = "_6g-0";
export var failedIcon = "_6g-4";
export var failedIconBadge = "_6g-3";
export var icon = "_6g-1";
export var successIcon = "_6g-2";